import type { CSSProperties } from "react";

const pageStyle: CSSProperties = {
  alignItems: "center",
  background:
    "radial-gradient(circle at top left, #e6f7f4 0, #f7fbfb 42%, #eef4f5 100%)",
  color: "#102a2d",
  display: "flex",
  fontFamily:
    "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif",
  justifyContent: "center",
  minHeight: "100vh",
  padding: "24px",
};

const cardStyle: CSSProperties = {
  background: "rgba(255, 255, 255, 0.96)",
  border: "1px solid #cde2e0",
  borderRadius: "20px",
  boxShadow: "0 24px 70px rgba(17, 75, 79, 0.14)",
  maxWidth: "560px",
  padding: "40px",
  width: "100%",
};

const badgeStyle: CSSProperties = {
  color: "#087f75",
  fontSize: "12px",
  fontWeight: 800,
  letterSpacing: "0.14em",
  margin: 0,
  textTransform: "uppercase",
};

const buttonRowStyle: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "12px",
  marginTop: "28px",
};

const primaryButtonStyle: CSSProperties = {
  background: "#087f75",
  border: 0,
  borderRadius: "10px",
  color: "#fff",
  cursor: "pointer",
  font: "inherit",
  fontWeight: 700,
  padding: "12px 18px",
};

const secondaryLinkStyle: CSSProperties = {
  alignItems: "center",
  border: "1px solid #bfd6d4",
  borderRadius: "10px",
  color: "#23484b",
  display: "inline-flex",
  fontWeight: 700,
  padding: "11px 18px",
  textDecoration: "none",
};

/**
 * Router-level fallback that deliberately has no provider or lazy-import
 * dependencies. It must remain renderable when a rolling deployment leaves an
 * already-open browser tab pointing at an obsolete bundle.
 */
export function ApplicationLoadError() {
  return (
    <main style={pageStyle}>
      <section style={cardStyle} role="alert">
        <p style={badgeStyle}>EvoLys application recovery</p>
        <h1 style={{ fontSize: "30px", lineHeight: 1.2, margin: "16px 0 12px" }}>
          We couldn&apos;t finish loading this page
        </h1>
        <p style={{ color: "#557174", lineHeight: 1.65, margin: 0 }}>
          EvoLys may have just been updated, or the connection was interrupted.
          Reload to retrieve the latest application version. Your saved work and
          login session will not be cleared.
        </p>
        <div style={buttonRowStyle}>
          <button
            type="button"
            style={primaryButtonStyle}
            onClick={() => window.location.reload()}
          >
            Reload latest version
          </button>
          <a href="/" style={secondaryLinkStyle}>
            Return to workspace home
          </a>
        </div>
      </section>
    </main>
  );
}
